import { Container, Content, Title, SmallText, IconWrapper } from './InfoMessage.styles'
import useInfoMessageStyle from './useInfoMessageStyle'

import { InfoMessageProps } from '.'

function InfoMessage({
  title,
  rightNode,
  text,
  children,
  nature = 'info',
  ...rest
}: InfoMessageProps): JSX.Element {
  const { color, background, Icon } = useInfoMessageStyle(nature)
  const inner = children || text
  return (
    <Container $color={color} $background={background} {...rest}>
      <IconWrapper $color={color}>
        <Icon color='inherit' />
      </IconWrapper>
      <Content>
        <Title>
          <span>{title}</span> {rightNode}
        </Title>
        {inner && <SmallText>{inner}</SmallText>}
      </Content>
    </Container>
  )
}

export default InfoMessage
